import {EnvironmentCabinet} from 'compob2b-libs';

export const environment = new EnvironmentCabinet();
